import { render, staticRenderFns } from "./ParamOcorrenciaForm.vue?vue&type=template&id=d5095524"
import script from "./ParamOcorrenciaForm.vue?vue&type=script&lang=js"
export * from "./ParamOcorrenciaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports